require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ens-de-lyon-bioing-et-sc-du-vivant-2-5-2-4.json") })
        }
      }, "path---ens-de-lyon-bioing-et-sc-du-vivant-2-5-2-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ens-de-lyon-bioing-et-sc-du-vivant-2-5-2-4!./.cache/json/ens-de-lyon-bioing-et-sc-du-vivant-2-5-2-4.json
// module id = 408
// module chunks = 231608221292675